import { Calendar, TimeOffEvent, TimeOffRequestsEvent } from '@nextforce/api'
import React from 'react'
import { View } from 'react-native'
import {
  HelperTimeOffEventView,
  getHelperTimeOffEventsHeight,
} from './helper_time_off'
import {
  StoreTimeOffEventView,
  getStoreTimeOffEventsHeight,
} from './store_time_off'

type Props = {
  event: TimeOffRequestsEvent
  expanded: boolean
  showSummaryTiles: boolean
  onStorePressTimeOff(storeId: string): void
  onEventExpand(event: TimeOffRequestsEvent): void
  onHelperPressPendingTimeOff(timeOffEvent: TimeOffEvent): void
}

export function TimeOffEventView({
  event,
  onStorePressTimeOff,
  onEventExpand,
  onHelperPressPendingTimeOff,
  expanded,
  showSummaryTiles,
}: Props) {
  if (!event.timeOffEvents.length) {
    return <></>
  }

  return (
    <View style={{ flex: 1 }}>
      {event.calendar === 'helper' ? (
        <HelperTimeOffEventView
          events={event.timeOffEvents}
          onPress={onHelperPressPendingTimeOff}
        ></HelperTimeOffEventView>
      ) : (
        <StoreTimeOffEventView
          event={event}
          expanded={expanded}
          showSummaryTiles={showSummaryTiles}
          onPressTimeOffCard={() => onStorePressTimeOff(event.storeId)}
          onEventExpand={onEventExpand}
        ></StoreTimeOffEventView>
      )}
    </View>
  )
}

export function getTimeOffEventsHeight(
  calendar: Calendar,
  timeOffEvents: TimeOffEvent[]
): number {
  if (!timeOffEvents.length) {
    return 0
  }
  switch (calendar) {
    case 'helper':
      return getHelperTimeOffEventsHeight(timeOffEvents)
    case 'store':
      return getStoreTimeOffEventsHeight(timeOffEvents)
  }
}
